// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiIdentitySubscriptionTargetAction } from '../models/ApiIdentitySubscriptionTargetAction';
import { HttpFile } from '../http/http';

export class ApiProfileMin {
    'id': string;
    'handle': string | null;
    'pfp': string | null;
    'banner1_color': string | null;
    'banner2_color': string | null;
    'cic': number;
    'rep': number;
    'tdh': number;
    'tdh_rate': number;
    'xtdh': number;
    'xtdh_rate': number;
    'level': number;
    'primary_address': string;
    'subscribed_actions': Array<ApiIdentitySubscriptionTargetAction>;
    'archived': boolean;
    'active_main_stage_submission_ids': Array<string>;
    'winner_main_stage_drop_ids': Array<string>;
    'artist_of_prevote_cards': Array<number>;
    'is_wave_creator': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "handle",
            "baseName": "handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "pfp",
            "baseName": "pfp",
            "type": "string",
            "format": ""
        },
        {
            "name": "banner1_color",
            "baseName": "banner1_color",
            "type": "string",
            "format": ""
        },
        {
            "name": "banner2_color",
            "baseName": "banner2_color",
            "type": "string",
            "format": ""
        },
        {
            "name": "cic",
            "baseName": "cic",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rep",
            "baseName": "rep",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "double"
        },
        {
            "name": "tdh_rate",
            "baseName": "tdh_rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "double"
        },
        {
            "name": "xtdh_rate",
            "baseName": "xtdh_rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "primary_address",
            "baseName": "primary_address",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscribed_actions",
            "baseName": "subscribed_actions",
            "type": "Array<ApiIdentitySubscriptionTargetAction>",
            "format": ""
        },
        {
            "name": "archived",
            "baseName": "archived",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "active_main_stage_submission_ids",
            "baseName": "active_main_stage_submission_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "winner_main_stage_drop_ids",
            "baseName": "winner_main_stage_drop_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "artist_of_prevote_cards",
            "baseName": "artist_of_prevote_cards",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "is_wave_creator",
            "baseName": "is_wave_creator",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiProfileMin.attributeTypeMap;
    }

    public constructor() {
    }
}
